'use client';

import type { FormCompletionContent, FormLeadStatus } from '@jlg-website/shared';
import QualifiedMessage from './qualified-message';
import NotQualifiedMessage from './not-qualified-message';
import DuplicatedMessage from './duplicated-message';

/**
 * Builds the `renderCompletion` callback the FormRenderer calls once a lead settles. Mirrors the
 * renderer's precedence: duplicated wins over qualified, which wins over not-qualified. Returns
 * `undefined` when no message is resolved, so the renderer falls back to its legacy path.
 */
export function buildRenderCompletion(completion?: FormCompletionContent) {
  if (!completion) return undefined;

  return function renderCompletion(status: FormLeadStatus) {
    if (status.is_duplicate) return <DuplicatedMessage data={completion.duplicated} />;
    if (status.is_qualified) return <QualifiedMessage data={completion.qualified} />;
    return <NotQualifiedMessage data={completion.not_qualified} />;
  };
}
